import axios, { AxiosError, AxiosResponse } from "axios";
import { SELECT_EMPTY } from "../consts";
import { ResponseModel } from "./Models";
//import fileDownload from "js-file-download";
//import { MESSAGE_TYPE } from "../consts";
// import AuthManager from "../oidc/index";

const httpClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 60000,
    decompress: true,
    responseType: "json",
});

httpClient.interceptors.request.use(
    (config) => {
        config.auth = {
            username: process.env.REACT_APP_BASIC_AUTH_USERNAME as string,
            password: process.env.REACT_APP_BASIC_AUTH_PASSWORD as string
        };

        const bodyData = config.data;
        if (bodyData && bodyData instanceof FormData) {
            config.headers["Content-Type"] = "multipart/form-data";
        }
        else {
            config.headers["Content-Type"] = "application/json";
        }

        config.headers["Accept-Language"] = "tr";
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

httpClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            //return AuthManager.login();
        }
        if (error.response.status === 403) {
            //errorHandler(error, "Bu işleme yetkiniz yok.", "Yetki Hatası");
            console.log(error, "Bu işleme yetkiniz yok.", "Yetki Hatası");
        }
        if (error.response.status === 400) {
            let traceId = error.response.data.traceId;
            let msg = '';
            if (error.response.data.errors[0].errorType === "ValidationError") {
                error.response.data.errors.map((t: any) =>
                    msg += `Mesaj: ${t.errorDesc} <br /> Alan: ${t.propertyDisplayName} <br /><br />`);
            }
            msg += `İzleme Numarası: ${traceId}`;

            //errorHandler(error, msg, "Hatalı İstek");
            console.log(error, msg, "Hatalı İstek");
        }
        return Promise.reject(error);
    }
);

/**
  * Sends http get request to giving endpoint
  *
  * @param {string} endpoint The endpoint
  *
  * @returns {ResponseModel} Return properties
  * 
  * `data`: if response is success, loaded data with giving T type. Otherwise null.
  * 
  * `fail`: true if received an exception, otherwise false.
  * 
  * `errorMessage`: if fail is true, you can find error message here.
*/
const get = async <T>(
    endpoint: string
): Promise<ResponseModel<T>> => {

    let response: ResponseModel<T> = {
        data: null,
        fail: false,
        errorMessage: ""
    };

    await httpClient
        .get<T>(endpoint)
        .then((res) => {
            response.data = res.data;
        })
        .catch((err: AxiosError<any>) => {
            console.log('axios error', err);
            response.fail = true;
            if (err.response?.data?.errors) {
                response.errorMessage = err.response.data.errors[0].errorDesc;
            }
        })
        .finally(() => {

        });
    return response;
};

/**
  * Sends http post request to giving endpoint
  *
  * @param {string} endpoint The endpoint
  * @param {Object} body The request body
  *
  * @returns {ResponseModel} Return properties
  * 
  * `data`: if response is success, loaded data with giving T type. Otherwise null.
  * 
  * `fail`: true if received an exception, otherwise false.
  * 
  * `errorMessage`: if fail is true, you can find error message here.
*/
const post = async <T>(
    endpoint: string,
    body: any,
): Promise<ResponseModel<T>> => {

    let response: ResponseModel<T> = {
        data: null,
        fail: false,
        errorMessage: ""
    };

    await httpClient
        .post<T>(endpoint, body)
        .then((res) => {
            response.data = res.data;
        })
        .catch((err: AxiosError<any>) => {
            console.log('axios error', err);
            response.fail = true;
            if (err.response?.data?.errors) {
                response.errorMessage = err.response.data.errors[0].errorDesc;
            }
        })
        .finally(() => {
        });
    return response;
};

/**
  * Sends http post request with attached file to giving endpoint
  *
  * @param {string} endpoint The endpoint
  * @param {Object} body The request body
  *
  * @returns {ResponseModel} Return properties
  * 
  * `data`: if response is success, loaded data with giving T type. Otherwise null.
  * 
  * `fail`: true if received an exception, otherwise false.
  * 
  * `errorMessage`: if fail is true, you can find error message here.
*/
const postWithFile = async <T>(
    endpoint: string,
    state: any
): Promise<ResponseModel<T>> => {

    const data = new FormData();
    for (var key in state) {
        if (state[key] !== undefined && state[key] !== null && state[key] !== SELECT_EMPTY) {
            if (state[key] instanceof Date) {
                data.append(key, new Date(state[key]).toLocaleDateString('tr'));
            }
            else {
                data.append(key, state[key])
            }
        }
    }

    let response: ResponseModel<T> = {
        data: null,
        fail: false,
        errorMessage: ""
    };

    await httpClient
        .post<T>(endpoint, data)
        .then((res) => {
            response.data = res.data;
        })
        .catch((err: AxiosError<any>) => {
            console.log('axios error', err);
            response.fail = true;
            if (err.response?.data?.errors) {
                response.errorMessage = err.response.data.errors[0].errorDesc;
            }
        })
        .finally(() => {

        });
    return response;
};

export { get, post, postWithFile };
